import { ChangeDetectorRef, Injectable, OnDestroy } from "@angular/core";

/**
 * A wrapper around the Angular ChangeDetectorRef. This
 * class provides a reusable mechanism for marking a change
 * detector as no longer in use and having subsequent calls
 * to detectChanges() ignored.
 * Injecting this into your component requires you to add it
 * to the list of providers in the @Component decorator.
 */
@Injectable()
export class ChangeDetectorWrapper implements OnDestroy {
    constructor(private _changeDetectorRef: ChangeDetectorRef) { }

    private _destroyed = false;

    public detectChanges(): void {
        if (!this._destroyed) {
            this._changeDetectorRef.detectChanges();
        }
    }

    public ngOnDestroy(): void {
        this._destroyed = true;
    }
}
